import { apiSlice } from './api.api-slice';

export interface PaymentDataModel {
  bankName: string;
  iban: string;
  bic: string;
}

export interface ValidateIBANDataResponse {
  isValid: boolean;
  paymentData?: PaymentDataModel;
  errors?: any;
}

export interface ValidateIBANDataRequest {
  iban: string;
}

export const ibanValidatorSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    validateIban: builder.mutation<ValidateIBANDataResponse, ValidateIBANDataRequest>({
      query: (arg) => ({
        url: '/iban-service/validate-iban',
        method: 'POST',
        body: arg,
      }),
      extraOptions: {
        applyProductPath: false,
      },
    }),
  }),
});

export const { useValidateIbanMutation } = ibanValidatorSlice;
